export default __webpack_public_path__ + "static/media/Rectangle 54.1f9a2cb5.png";